module.exports = __webpack_public_path__ + "assets/img/17_1036_big.64eafb55.jpg";